import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { placeholder } from 'src/app/models/placeholder';

@Component({
  selector: 'booking-history-item',
  templateUrl: './booking-history-item.component.html',
  styleUrls: ['./booking-history-item.component.scss'],
})
export class BookingHistoryItemComponent implements OnInit {
  @Input() bookingitem: any;
  public imagePlaceholder = placeholder;
  public displayStatus: string = '';
  public displayDate: string = '';
  public displayTitle: string = '';
  public displayImage: string = '';

  constructor() {}

  ngOnInit() {
    if (this.isFlightV2Booking()) {
      this.deriveFlightV2Display();
    } else {
      this.deriveDefaultDisplay();
    }
  }

  private isFlightV2Booking(): boolean {
    if (this.bookingitem?.source === 'v2') {
      return true;
    }
    if (this.bookingitem?.source === 'v1') {
      return false;
    }
    return (
      !!this.bookingitem?.tripType && Array.isArray(this.bookingitem?.itinerary)
    );
  }

  private deriveDefaultDisplay() {
    const rawStatus = this.bookingitem?.status || '';
    this.displayStatus = rawStatus.replace(/([A-Z])/g, ' $1').trim();
    this.displayTitle = this.bookingitem?.title || '';
    this.displayImage = this.bookingitem?.image || 'https://img.travelx.ai/Travelx_2/MaskGroup.png' || '';
    const hasVisitDate =
      (this.bookingitem?.serviceType === 'lounge' ||
        this.bookingitem?.serviceType === 'attractions') &&
      this.bookingitem?.visitDate;
    if (hasVisitDate) {
      this.displayDate = this.bookingitem.visitDate;
      if (this.bookingitem?.visitTime) {
        this.displayDate += ' • ' + this.bookingitem.visitTime;
      }
    } else {
      this.displayDate = this.bookingitem?.startDate || '';
    }
  }

  private deriveFlightV2Display() {
    this.displayStatus = this.bookingitem?.status || '';
    this.displayTitle = this.buildFlightRouteTitle();
    this.displayDate = this.bookingitem?.travelDate
      ? new DatePipe('en-US').transform(
          this.bookingitem.travelDate,
          'dd MMM yyyy'
        ) || ''
      : '';
    const onward = this.getOnwardLeg();
    this.displayImage = this.bookingitem?.image || 'https://img.travelx.ai/Travelx_2/MaskGroup.png' || '';
  }

  private getOnwardLeg(): any {
    const itinerary = Array.isArray(this.bookingitem?.itinerary)
      ? this.bookingitem.itinerary
      : [];
    return (
      itinerary.find((leg: any) => leg?.direction === 'ONWARD') || itinerary[0]
    );
  }

  private buildFlightRouteTitle(): string {
    const itinerary = Array.isArray(this.bookingitem?.itinerary)
      ? this.bookingitem.itinerary
      : [];
    const onward = this.getOnwardLeg();
    const onwardSegments = onward?.segments || [];
    if (!onwardSegments.length) {
      return '';
    }
    const origin = this.getStopName(onwardSegments[0]?.departure);
    const onwardDestination = this.getStopName(
      onwardSegments[onwardSegments.length - 1]?.arrival
    );

    if (this.bookingitem?.tripType === 'R') {
      return origin && onwardDestination
        ? `${origin} ⇄ ${onwardDestination}`
        : origin || onwardDestination;
    }

    if (this.bookingitem?.tripType === 'M') {
      const lastLeg = itinerary[itinerary.length - 1];
      const lastSegments = lastLeg?.segments || [];
      const finalDestination = this.getStopName(
        lastSegments[lastSegments.length - 1]?.arrival
      );
      return origin && finalDestination
        ? `${origin} → ${finalDestination}`
        : origin || finalDestination;
    }

    return origin && onwardDestination
      ? `${origin} → ${onwardDestination}`
      : origin || onwardDestination;
  }

  private getStopName(stop: any): string {
    return stop?.city || stop?.airportCode || '';
  }

  getStatusClass(status: string): string {
    const statusLower = (status || this.displayStatus || '').toLowerCase();
    if (statusLower.includes('cancelled') || statusLower.includes('failed') || statusLower.includes('released')) {
      return 'grey-danger-chip';
    } else if (statusLower.includes('confirmed') || statusLower.includes('successful') || statusLower.includes('success')) {
      return 'grey-status-chip';
    } else if (statusLower.includes('pending') || statusLower.includes('progress') || statusLower.includes('initiated')) {
      return 'grey-primary-chip';
    } else {
      return 'grey-primary-chip';
    }
  }
}
